import { RouteComponentProps } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import Spinner from '../../components/common/Spinner';
import { P2 } from '../../styles/FontStyles';
import { AuthLayoutTitle, Box } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';

const SignUp = ({ history }: RouteComponentProps) => {
  const { loading } = useAppSelector((state) => state.auth);

  return (
    <>
      {loading && <Spinner fullScreen={true} transparent />}

      <AuthLayoutTitle>Sign Up</AuthLayoutTitle>

      <Box
        mb='20'
        bg='#DAD9DD'
        border={`1px solid ${colors.neutral900}`}
        p='20px'
        br='30px'>
        <P2 mb='15'>
          As a customer, enjoy United One products at Retail cost.
        </P2>
        <Button
          color='#C4C3C6'
          textColor={colors.neutral900}
          fontFamily='Nulshock'>
          Sign Up as Customer
        </Button>
      </Box>
      <Box
        bg='#DAD0C9'
        border={`1px solid ${colors.neutral900}`}
        p='20px'
        mb='0'
        br='30px'>
        <P2 mb='15'>
          Start your business now, share these incredible products and the
          United One vision across the globe and seize the first-mover advantage
          at the inception of a company destined for greatness.
        </P2>
        <Button fontFamily='Nulshock'>Sign Up as Distributor</Button>
      </Box>
    </>
  );
};

export default SignUp;
